import { render } from "./Config.vue?vue&type=template&id=e35335c6&scoped=true&ts=true"
import script from "./Config.vue?vue&type=script&lang=ts"
export * from "./Config.vue?vue&type=script&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=e35335c6&scoped=true&lang=scss"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35335c6"]])

export default __exports__